import React from 'react'
import { Link } from 'react-router-dom'

const EmailNotSet = () => {
  return (
    <div className='text-[red] text-[13px]'>This email already exists. <Link to="/login" className='text-[#243677]'>Sign In</Link></div>
  )
}

export default EmailNotSet